export enum ENUM_ROLES {
	HAUPTWACHE = 'HAUPTWACHE',
	PERSONS = 'PERSONS',
	USERS = 'USERS',
	SETTINGS = 'SETTINGS',
	OPERATIONLISTS = 'OPERATIONLISTS'
};